
























import { Component } from '@niknevis/vue-modules'
import EntitySearchSelect from '@/modules/common/entity-search/components/shared/EntitySearchSelect.vue'
import { PropSync } from 'vue-property-decorator'
import Vue from 'vue'
import { AdminPredefinedAnswerRoute } from '@/modules/predefined-answer/routes/admin-predefined-answer.route'
import TextEllipsis from '@/modules/shared/components/shared/utils/TextEllipsisOld.vue'

@Component({
  components: {
    TextEllipsis,
    EntitySearchSelect
  }
})
export default class AdminPredefinedSearch extends Vue {
  constructor(
    private readonly routes: AdminPredefinedAnswerRoute
  ) {
    super()
  }

  @PropSync('preDefinedId') preDefinedIdValue: number | string

  private get route() {
    return this.routes.search()
  }
}
